<template>
  <el-table-column
    prop="county.name"
    label="Megye"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.address && scope.row.address.county" style="display: inline-block;">
        {{ scope.row.address.county.name }}
      </div>
      <div v-else>-</div>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'county.name',
  };
</script>
